import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { EmployeeMeritFault } from '../entities/employee-merit-fault';

@Injectable()
export class EmployeeMeritFaultService extends BaseCrudService<EmployeeMeritFault> {

  public uri = '/api/employeeMeritFault/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance EmployeeMeritFaultService');
  }

  buildSentence(entity?: EmployeeMeritFault, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.row ?
          `row${QueryOperator.Equal}${entity.row}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.eventDate ?
          `eventDate${QueryOperator.Contain}${entity.eventDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.documentNumber ?
          `documentNumber${QueryOperator.Contain}${entity.documentNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.documentDate ?
          `documentDate${QueryOperator.Contain}${entity.documentDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.comment ?
          `comment${QueryOperator.Contain}${entity.comment}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.meritFault) {
        query = query.concat(entity.meritFault.id ?
          `meritFault.id${QueryOperator.Equal}${entity.meritFault.id}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(entity.meritFault && entity.meritFault.type ?
          `meritFault.type.id${QueryOperator.Equal}${entity.meritFault.type.id}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
      }
      if (entity.supportingDocument && entity.supportingDocument.id) {
        query = query.concat(
          `supportingDocument.id${QueryOperator.Equal}${entity.supportingDocument.id}${QueryOperator.Split}`
        );
      }
      if (entity.employee && entity.employee.id) {
        query = query.concat(
          `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/employee-merit-fault.service.ts